import React from 'react';
import If from '../operator/if';
import styles from './Input.module.css';

const Select2 = ({ label, type, name, value, onChange, error, onBlur, invisible }) => {
  if (!invisible) {
  return (
    <div className={styles.wrapper} >
      <label htmlFor={name} className={styles.label}>
        {label}
      </label>
      <select name={name} value={value} id={name}
        onChange={onChange}
        onBlur={onBlur}
        className={styles.input}>
        <option value='1'>Arquivo</option>
        <option value='2'>Audio</option>
      </select>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
} else return null
};

export default Select2;
